import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicCartSummaryResponse {
  @jsonMember(Number)
  public readonly totalItemsPrice!: number;

  @jsonMember(Number)
  public readonly totalPrice!: number;
}
